import styled from 'styled-components'

import { SearchInputUnstyled } from 'Components/Header/SearchInput/unstyled'

export const SearchInput = styled(SearchInputUnstyled)`
  display: block;
  position: relative;
  height: 40px;
  width: 100%;

  input {
    position: relative;
    height: 100%;
    width: 100%;
    border: none;
    background: ${props => props.theme.colors.alabaster};
    border-radius: 4px;
    padding: 0 60px 0 20px;

    ::placeholder {
      color: ${props => props.theme.colors.placeholder};
      font-size: ${props => props.theme.fontSizes.header.searchPlaceholder};
    }
  }

  .search-icon {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    border-radius: 0 4px 4px 0;

    svg {
      fill: ${props => props.theme.colors.white};
      height: 100%;
      left: 0;
      right: 0;
    }
  }

  &.header-search {
    input {
      background: ${props => props.theme.colors.white};
    }

    .search-icon {
      background: ${props => props.theme.colors.alabaster};

      svg {
        fill: ${props => props.theme.colors.primary};
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Header/SearchInput/index.js